import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Switch from 'components/Switch';

export const Screen = styled.section`
  height: 100%;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${ColorPalette.HEX.White};
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  letter-spacing: -0.24px;
  color: ${ColorPalette.HEX.PineTree};
  margin-bottom: 20px;
`;

export const Body = styled.div`
  padding: 16px;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
    padding: 0;
  }
`;

export const BookingType = styled(Switch)`
  padding: 2px;

  & > li {
    padding: 8px;

    & > span {
      font-size: 16px;
    }
  }

  @media ${({ theme }) => theme.device.desktop} {
    width: 50%;
  }
`;
